import Vue from 'vue';
import Vuex from 'vuex';
import { initializeModule, store } from '@core/store';
import { dynameatModule } from './module';

Vue.use(Vuex);

initializeModule(dynameatModule);

store.registerModule('dynameat', dynameatModule);

export { store };
